function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.ec8dc441b76fb2966a9244c04fc914bd{fill:currentColor;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M0,0H16.872V16.872H0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "ec8dc441b76fb2966a9244c04fc914bd",
  d: "M9.624,9.624A2.812,2.812,0,1,0,6.812,6.812,2.811,2.811,0,0,0,9.624,9.624Zm0,1.406C7.747,11.03,4,11.972,4,13.842v.7a.705.705,0,0,0,.7.7h9.842a.705.705,0,0,0,.7-.7v-.7C15.248,11.972,11.5,11.03,9.624,11.03Z",
  transform: "translate(-1.188 -1.188)"
});

function SvgPersonProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.872 16.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonProfile);
export default __webpack_public_path__ + "static/media/person-profile.f1e8b69b.svg";
export { ForwardRef as ReactComponent };